import React, { useContext } from 'react';
import Pagination from '../../pagination/Pagination';
import { TableContext } from './provider/Provider';
import { TablePaginationProps } from '../component/types';

function TablePagination({
  pagination,
  rowLength,
}: {
  pagination: TablePaginationProps;
  rowLength: number;
}) {
  const { selectedIdsData } = useContext(TableContext);
  return pagination && pagination?.totalPage > 1 && rowLength > 0 ? (
    <div className="bg-white p-8 rounded-bottom-4 border-top">
      <Pagination
        {...pagination}
        onClick={(page) =>
          pagination.onClick(page, selectedIdsData.selectedIds)
        }
      />
    </div>
  ) : null;
}

export default TablePagination;
